module.exports = __webpack_public_path__ + "img/position-door.5ac12132.png";